export default __webpack_public_path__ + "static/media/banner.e678f2f2.svg";